import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Reporte/reportePlanilla';
import DetallePagoPlanilla from './detalle';

const mstp = state => {
    return {
        ...state.reportePlanilla,
        permisos: state.login.me.permisos
    }
};

const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(DetallePagoPlanilla)
